import { createFileRoute, redirect } from "@tanstack/react-router";

/** Dubblett av ordlistesidan – permanent omdirigering. */
export const Route = createFileRoute("/elskling")({
  beforeLoad: () => {
    throw redirect({ to: "/ordlista/$term", params: { term: "elskling" }, statusCode: 301 });
  },
});
